"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkUUN3IUQ2_js = require('./chunk-UUN3IUQ2.js');
var chunk356JBGIO_js = require('./chunk-356JBGIO.js');
var chunk2VCHSK65_js = require('./chunk-2VCHSK65.js');
var chunkLXX3SSRV_js = require('./chunk-LXX3SSRV.js');
var freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var t = require('styled-components');
var reactCheckbox = require('@radix-ui/react-checkbox');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var t__default = /*#__PURE__*/_interopDefaultLegacy(t);

var p=t__default["default"](chunk2VCHSK65_js.d).attrs({size:"regular"})``,o=t__default["default"](chunk2VCHSK65_js.d).attrs({size:"small"})`
  color: var(--foreground-tertiary);
`,e=t__default["default"](reactCheckbox.Root)`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  height: var(--spacing-regular);
  width: var(--spacing-regular);
  margin-top: 2px;
  // Donot update without prior design discussion
  border-radius: 3px;
  outline: none;
  border: var(--border-width-small) solid var(--border-boolean-default);
  background: none;

  &[data-state='checked'] {
    border: var(--border-width-small) solid
      var(--background-interactive-active-default);
  }
`,a=t__default["default"](reactCheckbox.Indicator)`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  color: var(--foreground-inverse);
  background-color: var(--background-interactive-active-default);
`,d=t__default["default"].label`
  display: block;
  padding: var(--spacing-small);
  color: var(--foreground-primary);
  font-size: var(--font-size-regular);
  font-weight: var(--font-weight-regular);
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`,C=t.css`
  border: var(--border-width-x-small) solid var(--border-error);

  ${d} {
    color: var(--foreground-primary);
  }

  ${o} {
    color: var(--foreground-tertiary);
  }

  ${a} {
    background-color: var(--background-interactive-error-default);
  }

  ${e} {
    border: var(--border-width-small) solid var(--foreground-error);

    &[data-state='checked'] {
      border: var(--border-width-small) solid
        var(--background-interactive-error-default);
    }
  }

  &:hover {
    border: var(--border-width-x-small) solid var(--border-boolean-error-hover);
    background: none;

    ${d} {
      color: var(--foreground-primary);
    }

    ${o} {
      color: var(--foreground-tertiary);
    }

    ${a} {
      background-color: var(--border-boolean-error-hover);
    }

    ${e} {
      border: var(--border-width-small) solid var(--border-boolean-error-hover);

      &[data-state='checked'] {
        border: var(--border-width-small) solid
          var(--border-boolean-error-hover);
      }
    }
  }

  &:focus-within {
    border: var(--border-width-x-small) solid var(--border-input-error);
    box-shadow: 0 0 0 var(--border-width-small)
      var(--border-input-error-outline);
  }
`,L=t.css`
  cursor: not-allowed;

  ${d} {
    color: var(--foreground-disabled);
    cursor: not-allowed;
  }

  ${o} {
    color: var(--foreground-disabled);
  }

  ${e} {
    border: var(--border-width-small) solid var(--border-input-disabled);

    &[data-state='checked'] {
      border: var(--border-width-small) solid var(--background-disabled);
    }
  }

  ${a} {
    background-color: var(--background-disabled);
  }

  &:hover {
    background: none;

    ${d} {
      color: var(--foreground-disabled);
    }

    ${a} {
      background-color: var(--background-disabled);
    }

    ${o} {
      color: var(--foreground-disabled);
    }

    ${e} {
      border: var(--border-width-small) solid var(--border-input-disabled);

      &[data-state='checked'] {
        border: var(--border-width-small) solid var(--background-disabled);
      }
    }
  }
`,g=t__default["default"].div`
  border: var(--border-width-x-small) solid transparent;
  border-radius: var(--spacing-small);

  ${({$fullWidth:r})=>!r&&"max-width: 320px;"}
  width: 100%;

  &:hover {
    background-color: var(--background-boolean-hover);

    ${d} {
      color: var(--foreground-primary);
    }

    ${a} {
      background-color: var(--background-interactive-active-hover);
    }

    ${o} {
      color: var(--foreground-secondary);
    }

    ${e} {
      border: var(--border-width-small) solid var(--border-boolean-hover);

      &[data-state='checked'] {
        border: var(--border-width-small) solid
          var(--background-interactive-active-hover);
      }
    }
  }

  &:focus-within {
    border: var(--border-width-x-small) solid var(--border-boolean-active-hover);
    box-shadow: 0 0 0 var(--border-width-small)
      var(--border-input-active-outline);
  }

  ${({$error:r})=>r&&C}
  ${({$disabled:r})=>r&&L}
`;var i=({id:r,children:m,error:f=!1,checked:c=!1,disabled:b=!1,fullWidth:k=!1,onCheckedChange:x,...w})=>jsxRuntime.jsx(g,{$error:f,$disabled:b,$fullWidth:k,children:jsxRuntime.jsx(d,{htmlFor:r,children:jsxRuntime.jsxs(chunkUUN3IUQ2_js.a,{yAlign:"flex-start",spacing:"small",children:[jsxRuntime.jsx(e,{id:r,disabled:b,checked:c,onCheckedChange:x,role:"checkbox","aria-checked":c,...w,children:jsxRuntime.jsx(a,{children:jsxRuntime.jsx(chunkLXX3SSRV_js.b,{icon:freeSolidSvgIcons.faCheck,size:"small","aria-hidden":"true"})})}),jsxRuntime.jsx(chunk356JBGIO_js.a,{spacing:"none",children:m})]})})});i.displayName="Checkbox";i.Label=p;i.Description=o;var D=t__default["default"](i)``;

exports.a = D;
